import { render, staticRenderFns } from "./Day.vue?vue&type=template&id=60f5ac2a&scoped=true&"
import script from "./Day.vue?vue&type=script&lang=js&"
export * from "./Day.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f5ac2a",
  null
  
)

export default component.exports